import axiosServices from 'utils/axios';
import type { AxiosResponse } from 'axios';

// No src/contracts/ schema exists for notifications — minimal shape from what
// hooks/useNotifications.ts actually reads off each item (AGENTS.md §1).
export interface Notification {
  id: string;
  type: string;
  title: string;
  body: string;
  createdAt?: string;
  readAt?: string | null;
  referenceId?: string | null;
}

interface NotificationsListResponse {
  data: Notification[];
}

interface UnreadCountResponse {
  unreadCount: number;
}

/**
 * Get paginated notifications for the current user.
 */
export const getNotifications = (page = 1, pageSize = 20): Promise<AxiosResponse<NotificationsListResponse>> =>
  axiosServices.get<NotificationsListResponse>('/notifications', { params: { page, pageSize } });

/**
 * Get unread notification count for the current user.
 */
export const getUnreadCount = (): Promise<AxiosResponse<UnreadCountResponse>> =>
  axiosServices.get<UnreadCountResponse>('/notifications/unread-count');

/**
 * Mark a single notification as read.
 */
export const markAsRead = (id: string): Promise<AxiosResponse<unknown>> => axiosServices.patch(`/notifications/${id}/read`);

/**
 * Mark all notifications as read.
 */
export const markAllAsRead = (): Promise<AxiosResponse<unknown>> => axiosServices.patch('/notifications/read-all');
